import DuckEntityForm from "ducks/DuckEntityForm";
import DuckEntity from "ducks/DuckEntity";

const paymentPlans = new DuckEntity('paymentPlans');
const paymentPlanForm = new DuckEntityForm('paymentPlanForm', paymentPlans, {
});

export {paymentPlans, paymentPlanForm};
